import pm_course from "/public/images/landing/courses/pm_course_icon.png";
import uiux_course from "/public/images/landing/courses/uiux_course_icon.png";

import { isCurrentTimeBetween } from "@/businessLogics/_common/date";

export const Title = () => {
  return <>모집 중인 코스</>;
};

export const PMDesc = () => {
  return (
    <>
      의사결정 잘 하는 PM이 되어, 시간이 지날수록
      <br />
      빛나는 커리어를 쌓아가세요.
    </>
  );
};

export const UIUXDesc = () => {
  return (
    <>
      데이터에 기반한 UIUX 역량을 바탕으로, 실무에서
      <br />
      인정받는 디자이너로 성장하세요.
    </>
  );
};

export const coursesInfo = (coursesInfo: {
  [key: string]: {
    round: string;
    subTitle: string;
    desc: string;
    alimStartDate: string;
    alimEndDate: string;
  };
}) => {
  return [
    {
      title: "PM 코스",
      subTitle: coursesInfo["pm"]?.subTitle,
      desc: coursesInfo["pm"]?.desc,
      icon: pm_course,
      url: "https://hanghae99.spartacodingclub.kr/pm",
      button: "지원하러 가기",
      course: "pm",
    },
    {
      title: "UIUX 디자이너 코스",
      subTitle: coursesInfo["uiux"]?.subTitle,
      desc: coursesInfo["uiux"]?.desc,
      icon: uiux_course,
      url: "alim",
      button: coursesInfo
        ? isCurrentTimeBetween(
            coursesInfo["uiux"]?.alimStartDate,
            coursesInfo["uiux"]?.alimEndDate
          )
          ? "알림 신청 하기"
          : "더 알아보기"
        : null,
      course: "designer",
    },
    // 마케터 코스 보완 계획에 따른 임시 주석 처리
    // {
    //   name: "그로스 마케터 코스",
    //   // discountInfo: "얼리버드 할인 진행 중",
    //   desc: <MktDesc />,
    //   icon: marketer_course,
    //   url: "alim",
    //   button: "알림신청 하기",
    //   course: "mkt",
    // },
  ];
};
